// extracted by mini-css-extract-plugin
export var alertIcon = "_oq-0";